import React from "react";
import { Table } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import classNames from "classnames";

import { currencyFormat } from "@lib/utils";

import CancelProductModal from "@LeagueManagement/Order/components/CancelProductModal";
import ReinstateProductModal from "@LeagueManagement/Order/components/ReinstateProductModal";
import { ProductDetailsProps } from "@LeagueManagement/Order/types/order";

import ProductManagementButtons from "./ProductManagementButtons";

const ProductDetails = ({
    order,
    product,
    showModal,
    handleClose,
    handleShow,
    handleSubmit,
}: ProductDetailsProps): React.ReactNode => {
    const location = useLocation();
    const isOnLeagueManagement = /league-management/.test(location.pathname);

    return (
        <>
            <Table
                borderless
                className={classNames({
                    productDetails: true,
                    cancelled:
                        isOnLeagueManagement && product.status === "cancelled",
                })}
                data-testid="productDetails"
            >
                <thead>
                    <tr>
                        <th colSpan={2}>{product.description}</th>
                    </tr>
                </thead>
                <tbody>
                    {isOnLeagueManagement && product.status === "cancelled" && (
                        <tr>
                            <td
                                colSpan={2}
                                className={classNames(
                                    "text-decoration-none",
                                    "text-center",
                                )}
                            >
                                <h6 className={classNames("text-danger")}>
                                    Registration Cancelled
                                </h6>
                            </td>
                        </tr>
                    )}
                    {!isOnLeagueManagement && order.id && (
                        <tr>
                            <td>
                                <h5>Order Number:</h5>
                            </td>
                            <td>{order.id}</td>
                        </tr>
                    )}
                    <tr>
                        <td>
                            <h5>Cost:</h5>
                        </td>
                        <td>{currencyFormat.format(product.orderPrice)}</td>
                    </tr>
                    <tr>
                        <td>
                            <h5>New or Returning Team:</h5>
                        </td>
                        <td>{product.meta.teamType}</td>
                    </tr>
                    <tr>
                        <td>
                            <h5>Team Name</h5>
                        </td>
                        <td>{product.meta.teamName}</td>
                    </tr>
                    {isOnLeagueManagement && (
                        <>
                            <tr>
                                <td>
                                    <h5>Team Id:</h5>
                                </td>
                                <td>{product.meta.teamId}</td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    {handleShow && (
                                        <ProductManagementButtons
                                            handleShow={handleShow}
                                            status={product.status}
                                        />
                                    )}
                                </td>
                            </tr>
                        </>
                    )}
                </tbody>
            </Table>
            {isOnLeagueManagement &&
                (product.status === "cancelled" ? (
                    <ReinstateProductModal
                        show={showModal!}
                        handleClose={handleClose!}
                        handleSubmit={handleSubmit!}
                        product={product}
                        order={order}
                    />
                ) : (
                    <CancelProductModal
                        show={showModal!}
                        handleClose={handleClose!}
                        handleSubmit={handleSubmit!}
                        product={product}
                        order={order}
                    />
                ))}
        </>
    );
};

export default ProductDetails;
